// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__201S2","Title":"Main_Title__1Rwka"};